import flatMap from 'lodash/flatMap';
import filter from 'lodash/filter';


// keeps the previous array so that an unchanged selection keeps its reference, see getSelectedInstallations
let lastSelectedInstallations = [];

/**
 * returns every selected service across all installations.
 *
 * flatMap() builds a brand new array on every call, so calling this straight from mapStateToProps
 * makes connect() re-render on every single dispatch even when nothing about the installations
 * changed. The previous array reference is reused whenever the selected services are the same,
 * which keeps the shallow comparison in connect() happy.
 *
 * @param instList {array} store.instState.instList
 * @returns {array} selected services
 */
export const getSelectedInstallations = (instList) => {
  const installations = flatMap(instList, instItem => filter(instItem.services, {selected: true}));
  const isSameAsBefore = installations.length === lastSelectedInstallations.length
    && installations.every((service, index) => service === lastSelectedInstallations[index]);
  if (isSameAsBefore) {
    return lastSelectedInstallations
  }
  lastSelectedInstallations = installations;
  return installations
};
